import React, { useEffect, useRef, useState }  from 'react';
import styled from 'styled-components'
import 'mapbox-gl/dist/mapbox-gl.css';
import Header from "./Header";
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import mapboxgl from '!mapbox-gl' // eslint-disable-line import/no-webpack-loader-syntax




const Map =  () => {

  const [marker, setMarker] = useState('47.79560999760509, 3.568792311528775')

const mapContainer = useRef(null);
const map = useRef(null);
const [lng, setLng] = useState(3.568792311528775);
const [lat, setLat] = useState(47.79560999760509);
const [zoom, setZoom] = useState(17.5);

useEffect(() => {
if (map.current) return; // initialize map only once


map.current = new mapboxgl.Map({
container: mapContainer.current,
style: 'mapbox://styles/mapbox/streets-v11',
center: [lng, lat],
zoom: zoom
});
});     
 
useEffect(()=>{
  if (!map.current) return; // wait for map to initialize
map.current.addControl(new mapboxgl.NavigationControl());

},[])


useEffect(() => {
if (!map.current) return; // wait for map to initialize


map.current.on('move', () => {
setLng(map.current.getCenter().lng.toFixed(4));
setLat(map.current.getCenter().lat.toFixed(4));
setZoom(map.current.getZoom().toFixed(2));
});
});

mapboxgl.accessToken =
  "pk.eyJ1IjoibWF0dGVvZHY4OSIsImEiOiJja3kzcTJiejMwNGhvMzBweWhlbWxxODE4In0.x6eIw1nJpEmcrnSkH62pCg";


    return (
      <>       
      <Header/>
      <Container>

       <div className="textBox">
         <h3> 11 Pl. Charles Lepère, 89000 Auxerre</h3>
         <h4>Du mardi au jeudi de 17h à 1h & du vendredi au samedi de 17h à 2h</h4>
         
       </div>

        <div ref={mapContainer} className="map-container" />
       
          <Footer>
            <ul>
              <li>Retrouvez-nous sur </li>
              <li><a href='https://www.instagram.com/lessentielbar/?hl=fr'><InstagramIcon/></a></li>
              <li><a href="https://m.facebook.com/LEssentiel-Cocktail-Bar-347876362684784/"><FacebookIcon/></a></li>
            </ul>
          </Footer>
        
        </Container>
       

    </>
        
    );
};



const Footer = styled.div`
position:absolute;
bottom: 40px;
width: 100%;
height: 40px;
background-color: rgb(0,0,0,0.5);
display:flex;
justify-content:center,
align-items:center;

ul{
  display:flex;
  justify-content:center;
  align-items:center;
  
  width: 100%;
  color:#a1df98;
  list-style:none;
  gap:10px;
  font-size: 14px;
  font-weight: 700;
  font-family:'Poppins';
  
  a{
    color:#a1df98;
  }
}
`

const Container = styled.div`
width: 100%;
height: 100vh;

background-color: rgb(0,0,0,0.8);
display:flex;
flex-direction: column;

justify-content: center;



.textBox{
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items:center;
  text-align:center;
  gap: 12px;
  font-family:'Poppins';
  color: #f9f9f9;
  
  width: 90vw;
  position:relative;
  left:50%;
  transform: translateX(-50%);
  margin-bottom: 50px;
  border-radius: 10px;
  background-color: #062b16;
  padding: 15px 0px;
  box-shadow: 0px 0px 5px 5px rgb(0,0,0,0.2);

  h3{
    font-family:'Lobster';
    font-weight:400;
    font-size: 1.5em;
    padding: 0px 10px;
  }
}

h4{
  padding:0px;
  margin:0px;
   width: 80%;
  text-align:left;
  font-size: 16px;
  text-align:center;

}

 


.map-container{
  height:50vh;
  width: 90vw;
  border-radius: 12px;
  position: relative;
  left: 50%;
  transform:translate(-50%);
  margin-bottom: 50px;

  

`

export default Map;